import { Colors } from '@oy/uicore';
import { Message, StringTemplate, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';

export const InstantWithdrawalError = (props: {
  isNotInService: boolean;
  isOpeningLessThanClosing: boolean;
  formattedTime: string;
  isExceedLimit: boolean;
}) => {
  const { getTranslation } = useTranslate();

  if (props.isNotInService)
    return (
      <Text textStyle={Text.Style.BodyMdRegular} color={Colors.BLACK40}>
        <StringTemplate
          str={getTranslation(
            props.isOpeningLessThanClosing
              ? 'withdrawal_warning_eod_bca_available'
              : 'withdrawal_warning_eod_bca_not_available',
          )}
          template={{
            time: <b>{props.formattedTime}</b>,
          }}
        />
      </Text>
    );

  if (props.isExceedLimit)
    return (
      <Message type={Message.Type.Warning} showIcon>
        {getTranslation('withdrawal_instantType_notAvailable')}
      </Message>
    );
  return null;
};
